/* Encapsulates and collects javascript global object calls for refactoring */
export class TopoGlobalObjectsConnector {
    static GetBasicJSHoverThumbObject(){
        return hoverThumb;
    }

    static GetBasicJSTopoObject(){
        return topo;
    }

    static GetBasicJSDrawingOptions(){
        return drawingOptions;
    }

    static GetHeadPHPOtherArchivesObject(){
        return otherArchives;
    }

    static GetIndexJSGlobalResultObject(){
        return res;
    }

    static GetIndexJSGlobalGalleryResultObject(){
        return gres;
    }

    static GetIndexJSBackgroundSearchTerms() {
        return backgroundSearchTerms;
    }

    static GetIndexJSDoSearch(ev, searchterm, toPage, itemsPerPage) {
        dosearch(ev, searchterm, toPage, itemsPerPage);
    }

    static GetIndexJSSearchString(){
        return searchstring();
    }

    /* Delegated Method Calls */
    static CallBasicJSClearCircle(circle) {
        clearCircle(circle);
    }

    static CallBasicJSDrawPoly(
        markerArray,
        gMapPolygon, gMapCircle, gMapProjection,
        maxLength, frontend, fillPoly
    ) {
        return drawPoly(markerArray,
            gMapPolygon, gMapCircle, gMapProjection,
            maxLength, frontend, fillPoly
        );
    }

    static CallBasicJSClearPoly(poly) {
        clearPoly(poly);
    }

    static CallBasicJSFitMapToMarkers(map, markers, pan = false, zoomidle = true) {
        fitMapToMarkers(map, markers, pan, zoomidle);
    }

    static CallBasicJSCreateMarker(map, position, markerCount, markerOptions, noPosts) {
        return createMarker(map, position, markerCount, markerOptions, noPosts);
    }

    static CallBasicJSHandleMaxZoom(googleMap) {
        HandleMaxZoom(googleMap);
    }

    static CallIndexJSSetSearchterm(searchTerm) {
        setSearchterm(searchTerm);
    }
}